// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Input__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Input/Input.scss
 ** module id = 919
 ** module chunks = 1
 **/